"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Shamelessly nicked from Dan Abramov:
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// Adjusted with toggle and reset functionality.
function useInterval(callback, delay) {
  var savedCallback = (0, _react.useRef)();
  var interval = (0, _react.useRef)();

  var _useState = (0, _react.useState)(delay),
      _useState2 = _slicedToArray(_useState, 2),
      currentDelay = _useState2[0],
      setDelay = _useState2[1]; // Start or stop an interval from happening.


  var toggle = (0, _react.useCallback)(function () {
    return setDelay(function (currentDelay) {
      return currentDelay === null ? delay : null;
    });
  }, [delay]); // Function to allow resetting our interval.

  var reset = (0, _react.useCallback)(function () {
    return clearInterval(interval.current);
  }, [interval]); // Remember the latest callback.

  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  (0, _react.useEffect)(function () {
    function tick() {
      savedCallback.current();
    } // If there is an existing interval when we reset and/or change our delay, get rid of it.


    if (interval.current) reset(); // If we have a delay (and it is above 0), then set up our new interval.

    if (currentDelay) {
      interval.current = setInterval(tick, delay);
    }

    return reset;
  }, [currentDelay, reset]);
  return {
    toggle: toggle,
    reset: reset
  };
}

var _default = useInterval;
exports["default"] = _default;